import React, {useCallback, useEffect, useState} from 'react';
import HubspotCalendar from '../components/shared/HubspotCalendar';

export const GlobalContext = React.createContext({
  state: {},
  openContactForm: () => {
  },
  closeContactForm: () => {
  }
});

export const GlobalContextProvider = ({children, location}) => {
  // global state that can be accessed by all other components
  const [state, setState] = useState({});
  const [contactFormIsVisible, setContactFormIsVisible] = useState(false);

  const openContactForm = useCallback(() => {
    setContactFormIsVisible(true);
  }, []);

  const closeContactForm = useCallback(() => {
    setContactFormIsVisible(false);
  }, []);

  useEffect(() => {
    if (window.location.href.endsWith('#contact_us')) {
      openContactForm();
    }
  }, []);

  return (
      <GlobalContext.Provider
          value={{state: state, openContactForm: openContactForm, closeContactForm: closeContactForm}}>
        {children}
        {
          contactFormIsVisible &&
          <HubspotCalendar/>
        }
      </GlobalContext.Provider>
  );
};
